import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

// Core components
import Button from "components/CustomButtons/Button.jsx";

class SelectLibraryDocuments extends React.Component {

    constructor (props) {

        super(props);
        this.state = {
            documents: this.props.selected_documents ? this.props.selected_documents : []
        };
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.selected_documents !== null || nextProps.selected_documents !== undefined) {
            this.setState({
                "documents": nextProps.selected_documents
            });
        }
    }

    render () {
        const {classes} = this.props;
        const client_documents = this.props.client_documents.map((prop, key) => prop.id);
        return (
            <Dialog
                aria-describedby="update-profile-confirm-modal-slide-description"
                aria-labelledby="small-modal-slide-title"
                classes={{
                    "root": `${classes.center} ${classes.modalRoot}`,
                    "paper": `${classes.modal} ${classes.modalSmall}`
                }}
                keepMounted
                onClose={() => this.props.onClose("selectLibraryDocumentsModal")}
                open={this.props.selectLibraryDocumentsModal}
            >
                <DialogTitle
                    className={`${classes.modalBody} ${classes.modalSmallBody}`}
                    style={{"paddingBottom": "0px"}}
                >
                    Select Available Documents
                </DialogTitle>
                <DialogContent
                    className={`${classes.modalBody} ${classes.modalSmallBody}`}
                    id="update-profile-confirm-modal-slide-description"
                >
                    <FormControl
                        disabled={this.state.is_view}
                        fullWidth
                        className={classes.selectFormControl}
                    >
                        <InputLabel
                            className={classes.selectLabel}
                        >
                            Select Available Documents
                        </InputLabel>
                        <Select
                            value={this.state.documents ? this.state.documents : []}
                            onChange={(event) => this.setState({'documents': event.target.value})}
                            multiple
                            MenuProps={{"className": classes.selectMenu}}
                            classes={{"select": classes.select}}
                            inputProps={{
                                name: 'documents',
                                id: 'documents'
                            }}
                        >
                            {this.props.document_library !== null
                                ? this.props.document_library.filter((document) => {
                                    return !client_documents.includes(document.id);
                                }).map((prop, key) => 
                                    <MenuItem
                                        key={"document_" + key}
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelectedMultiple
                                        }}
                                        value={prop.id}
                                    >
                                        {'id: (' + prop.id + ') ' + prop.filename}
                                    </MenuItem>
                                    )
                                : ""}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions
                    className={`${classes.modalFooter} ${classes.modalFooterCenter}`}
                >
                    <Button
                        className={classes.modalSmallFooterFirstButton}
                        color="transparent"
                        onClick={() => this.props.onClose("selectLibraryDocumentsModal")}
                    >
                        Close
                    </Button>
                    <Button
                        className={
                            `${classes.modalSmallFooterFirstButton
                            } ${
                                classes.modalSmallFooterSecondButton}`
                        }
                        color="success"
                        disabled={this.props.btnDisabled}
                        onClick={(event) => {
                            event.preventDefault();
                            this.props.handleAddDocuments(this.state.documents);
                        }}
                        simple
                        >
                        Accept
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(extendedFormsStyle)(SelectLibraryDocuments);
